import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import supabase from "../config/supabaseClient";
import '../index2.css';

const AddCallsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [players, setPlayers] = useState([]);
  const [game, setGame] = useState(null);
  const [calls, setCalls] = useState({});
  const gameId = new URLSearchParams(location.search).get('gameId');

  useEffect(() => {
    const fetchGameAndPlayers = async () => {
      try {
        // 1. Fetch the game to get its group_id and year_id
        const { data: gameData, error: gameError } = await supabase
          .from('game')
          .select('id, group_id, year_id')
          .eq('id', gameId)
          .single();

        if (gameError) throw gameError;
        setGame(gameData);

        // 2. Get players from players_year with same group_id and year_id
        const { data: playerYearData, error: pyError } = await supabase
          .from('players_year')
          .select('player_id')
          .eq('group_id', gameData.group_id)
          .eq('year_id', gameData.year_id);

        if (pyError) throw pyError;

        const playerIds = playerYearData.map(p => p.player_id);

        if (playerIds.length === 0) {
          setPlayers([]);
          return;
        }

        // 3. Fetch the actual players
        const { data: playersData, error: playersError } = await supabase
          .from('players')
          .select('id, Name')
          .in('id', playerIds);

        if (playersError) throw playersError;

        setPlayers(playersData || []);
      } catch (error) {
        console.error('Error fetching game/players:', error.message || error);
        setPlayers([]);
      }
    };

    fetchGameAndPlayers();
  }, [gameId]);

  const handleCallChange = (playerId, value) => {
    setCalls(prevCalls => ({ ...prevCalls, [playerId]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const inserts = Object.keys(calls).map(playerId => ({
        game_id: gameId,
        player_id: parseInt(playerId),
        call: calls[playerId]
      }));

      const { error } = await supabase
        .from('call_players_game')
        .insert(inserts);

      if (error) throw error;

      navigate(`/game/${gameId}`);
    } catch (error) {
      console.error('Error inserting calls:', error.message || 'Unknown error');
    }
  };

  return (
    <div className="page add-calls">
      <h2>Add Calls to Players for Game {gameId}</h2>
      <form onSubmit={handleSubmit}>
        {players.length === 0 ? (
          <p>No players found for this game's group and year.</p>
        ) : (
          players.map(player => (
            <div key={player.id} className="player-call">
              <label>
                {player.Name}:
                <select
                  value={calls[player.id] || ''}
                  onChange={(e) => handleCallChange(player.id, e.target.value)}
                >
                  <option value="">Select Status</option>
                  <option value="summoned">Summoned</option>
                  <option value="not_summoned">Not Summoned</option>
                </select>
              </label>
            </div>
          ))
        )}
        <button type="submit">Submit Calls</button>
      </form>
    </div>
  );
};

export default AddCallsPage;
